module.exports = __webpack_public_path__ + "media/images/Blog-Next-Arrow-ee1d6cccd09ede1d81da98187a155803.png";